import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseBillReportComponent } from '../../baseBillReport.component';
import { DeleteBillProvicerService } from '../services/bill-provider-delete.service';
import { BillProviderReportService } from '../services/bill-provider-report.service';

@Component({
  selector: 'app-bill-provider-list',
  templateUrl: './bill-provider-list.component.html',
  styleUrls: ['./bill-provider-list.component.scss'],
})
export class BillProviderListComponent
  extends BaseBillReportComponent
  implements OnInit
{
  displayTableColumns: { [key: string]: string } = {
    name: 'Name',
    image: 'image',
    createdAt: 'Created At',
  };
  properties = ['name', 'image', 'createdAt'];

  columnTypes = {
    image: 'img',
    createdAt: 'date',
  };
  constructor(
    billProviderReportService: BillProviderReportService,
    billProviderDelete: DeleteBillProvicerService,
    route: Router,
    cdr: ChangeDetectorRef,
    activeRoute: ActivatedRoute
  ) {
    super(
      billProviderReportService,
      billProviderDelete,
      route,
      cdr,
      activeRoute
    );
    super.setDisplayMessage('bill Provider');
  }
}
